<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    confirm-text="保存"
    :title="title"
    width="30%"
    :confirm-disable="false"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="100px"
        class="w-60"
      >
        <el-form-item
          label="线下课程名称"
          prop="offlineCourseId"
        >
          <el-select
            v-model="createForm.offlineCourseId"
            filterable
            clearable
            placeholder="请选择课程名称"
            class="w-50"
          >
            <el-option
              v-for="course in courseList"
              :key="course.id"
              :label="course.courseName"
              :value="course.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="导入文件"
          prop="fileName"
        >
          <el-upload
            ref="upload"
            action=""
            :on-change="changeFile"
            :on-remove="removeFile"
            :auto-upload="false"
            :limit="1"
            accept=".xls,.xlsx"
          >
            <el-button
              type="primary"
            >
              导入EXCEL
            </el-button>
          </el-upload>
          <el-input
            v-show="false"
            v-model="createForm.fileName"
          />
        </el-form-item>
      </el-form>
      <el-link
        :href="downloadUrl"
        target="_blank"
        type="primary"
        class="link"
      >
        模板下载
      </el-link>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';

const config = require('../../../httpConfig');

export default {
  name: 'ImportExcelDialog',
  components: { customeDialog },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [Object, null],
      default: null,
    },
    courseList: {
      type: [Array],
      default: () => [],
    },
  },
  data() {
    return {
      title: '证书导入',
      cancelText: '取消',
      btnType: false,
      file: {},
      createForm: {
        offlineCourseId: null,
        fileName: null,
      },
      creatRules: {
        offlineCourseId: [
          { required: true, message: '请选择线下课程', trigger: 'change' },
        ],
        fileName: [
          { required: true, message: '请选择文件', trigger: 'change' },
        ],
      },
    };
  },
  computed: {
    downloadUrl() {
      return `${process.env.VUE_APP_HOST_ENV === 'dev' ? config.dev : config.prod}/api/user/course/cert/listExample`;
    },
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.file = null;
          this.$refs.upload.clearFiles();
          this.createForm.fileName = null;
          this.$refs.createForm.clearValidate();
        });
      }
    },
  },
  methods: {
    close() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close');
    },
    confirm() {
      this.$refs.createForm.validate(async (valid) => {
        if (this.btnType) return;
        this.btnType = true;
        if (valid) {
          const fileFormData = new FormData();
          fileFormData.append('file', this.file.raw, this.createForm.fileName);
          fileFormData.append('offlineCourseId', this.createForm.offlineCourseId);
          const data = await axClient.cert.certImportExcel(fileFormData);
          this.btnType = false;
          if (!data) return;
          this.$message.success('导入成功');
          this.$emit('update:dialogVisible', false);
          this.$emit('confirm');
        }
      });
    },
    changeFile(file) {
      this.file = file;
      this.createForm.fileName = file.name;
    },
    removeFile() {
      this.file = null;
      this.createForm.fileName = null;
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: 200px;
  .w-60{
    width: 60%;
  }
  .link{
    margin-top: -10px;
    float: right;
  }
}
</style>
